// extracted by mini-css-extract-plugin
export default {"label":"label--J380v"};